import styled, { css } from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 1px;
	user-select: none;
`;

const StyledButton = styled.div<{
	$disabled?: boolean;
	$direction: 'left' | 'right';
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border-radius: ${({ $direction }) =>
		$direction === 'left' ? '5px 0 0 5px' : '0 5px 5px 0'};
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition:
		background-color 0.3s ease,
		border 0.3s ease;

	${(props) =>
		props.$disabled
			? css`
					background-color: rgba(255, 255, 255, 0.02);
					border: 1px solid rgba(255, 255, 255, 0.05);

					img {
						opacity: 0.25;
					}
			  `
			: css`
					cursor: pointer;
					&:hover {
						background-color: #ffffff;

						img {
							filter: invert(100%);
						}
					}
			  `}

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition:
			opacity 0.3s ease,
			filter 0.3s ease;
	}
`;

const StyledInput = styled.input`
	width: 50px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);

	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 700;
	font-size: 12px;
	line-height: 14px;
	color: #ffffff;
	text-align: center;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;
	user-select: none;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}

	&:focus-visible {
		outline: none;
	}

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		appearance: none;
	}
`;

export { StyledButton, StyledContainer, StyledInput };
